import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { Success } from '../Synchronizable/SyncResult';
import { FamilyMember } from './FamilyMember';

export async function recordFailedParent(
  failedParents: RxdbCollectionNameV2[],
  sync: (parent: FamilyMember<unknown>) => Promise<Success>,
  parent: FamilyMember<unknown>,
): Promise<Success> {
  try {
    const result = await sync(parent);
    return result;
  } catch (error) {
    failedParents.push(parent.name);
    throw error;
  }
}
